/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button';
import IconHelp from 'components/Icons/Help';
import Paragraph from 'components/Paragraph/Paragraph';

import styles from './HelpScreen.module.scss';

const HelpScreen = () => {
  const history = useHistory();

  const contact = () => {
    window.location.href =
      'mailto:support@cureoscity.com?subject=Login Support';
  };

  return (
    <>
      <Helmet>
        <title>Help Portal</title>
      </Helmet>
      <div className={styles['login-box']}>
        <IconHelp size="110px" />
        <h2>Having trouble?</h2>
        <div className={styles['wrapper-cta']}>
          <Paragraph>
            Click the button below and a member of our team will assist you as
            soon as possible.
          </Paragraph>
          <div className={styles['help-cta']}>
            <Button
              type="button"
              text="Contact"
              appearance="primary"
              size="full-width"
              onClick={contact}
            />
            <Button
              type="button"
              text="Back to login"
              appearance="text"
              size="full-width"
              onClick={() => history.push('/login')}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpScreen;
